export default __webpack_public_path__ + "static/media/challenges_hero.e4bf9adf.png";